import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { collection, doc, getDoc, setDoc, getDocs } from "firebase/firestore";
import { firebaseConstants, getDb } from "../../../util/Constants";
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import _ from "lodash";

const bcrypt = require("bcryptjs");
const salt = bcrypt.genSaltSync(10);

export default function EditUser({ signedInUser }) {
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState("data");
  const [startDate, setStartDate] = useState(new Date());
  const [isChecked, setIsChecked] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [regions, setRegions] = useState([]);
  const [registrationFeilds, setRegistrationFeilds] = useState([]);

  const history = useHistory();
  let { userId } = useParams();
  userId = decodeURIComponent(userId);

  const db = getDb();
  const utilRef = collection(db, firebaseConstants.dbUtil);
  const usersRef = collection(db, firebaseConstants.dbUsers);

  useEffect(() => {
    getUser().then((_user) => {
      _user.password = null;
      setUserData(_user);
      if (_user.canExpire) setIsChecked(_user.canExpire);
      getEventData(_user.eventId).then((data) => {
        console.log(data);
        setRegistrationFeilds(data.registrationFeilds);
        setRegions(data.regions);
        setDepartments(data.departments);
      });

      setLoading(null);
    });
  }, []);

  const getEventData = async (eventId) => {
    console.log(eventId, "Event Id in");
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        registrationFeilds: data.registrationFields,
        departments: data.departments,
        regions: data.region,
      };
    }
  };

  const getUser = async () => {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { id: doc.id, ...docSnap.data() };
    } else {
      // doc.data() will be undefined in this case
      history.goBack();
    }
  };

  const getMetaData = async () => {
    let data = {};
    const docRef = doc(utilRef, "meta");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      data = docSnap.data();
    }

    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading("saving");
    let expiryDate = null;
    console.log(   signedInUser.projectType === "progress"
    ? userData.region.length > 0
      ? userData.region
      : regions[0]
    : "",);

    try {
      if (isChecked) {
        if (moment()._d < userData.expiryDate) {
          expiryDate = moment(userData.expiryDate).valueOf();
        } else {
          alert("timestamp not set or is before tomorrow");
          setLoading(null);
          return;
          // throw "timestamp not set or is before tomorrow";
        }
        await setDoc(
          doc(db, "users", userId),
          {
            department:
              signedInUser.projectType === "progress"
                ? userData.department.length > 0
                  ? userData.department
                  : departments[0]
                : "",
            email: userData.email,
            email_insensitive: userData.email.toLowerCase(),
            isActive: true,
            name: userData.name,
            name_insensitive: userData.name.toLowerCase(),
            region:
              signedInUser.projectType === "progress"
                ? userData.region.length > 0
                  ? userData.region
                  : regions[0]
                : "",
            expiryDate: expiryDate,
            canExpire: isChecked,
          },
          { merge: true }
        );
      } else {
        expiryDate = null;
        await setDoc(
          doc(db, "users", userId),
          {
            department:  signedInUser.projectType === "progress"
            ? userData.department.length > 0
              ? userData.department
              : departments[0]
            : "",
            email: userData.email,
            email_insensitive: userData.email.toLowerCase(),
            isActive: true,
            name: userData.name,
            name_insensitive: userData.name.toLowerCase(),
            region: signedInUser.projectType === "progress"
            ? userData.region.length > 0
              ? userData.region
              : regions[0]
            : "",
            //password: passwordHash,
            expiryDate: expiryDate,
            canExpire: isChecked,
          },
          { merge: true }
        );
      }
      history.push(`/admin/users/${localStorage.getItem("eventId")}`);
    } catch (e) {}
  };

  return (
    <>
      {/* <div className="header pb-8 pt-5 pt-md-8" /> */}
      <Container fluid>
        <Row className="mb-4">
          <Col>
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">Edit User</h2>
              </CardHeader>
              <CardBody>
                {loading !== "data" ? (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-2 justify-content-center">
                      <Col lg={8}>
                        <Row>
                          <Col lg={6}>
                            <FormGroup>
                              <Label for="name">Name</Label>
                              <Input
                                type="text"
                                name="name"
                                id="name"
                                value={userData.name}
                                className="form-control-alternative"
                                required
                                onChange={(e) => {
                                  setUserData({
                                    ...userData,
                                    name: e.target.value,
                                    name_insensitive:
                                      e.target.value.toLowerCase(),
                                  });
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg={6}>
                            <FormGroup>
                              <Label for="email">Email</Label>
                              <Input
                                type="email"
                                name="email"
                                id="email"
                                value={userData.email}
                                className="form-control-alternative"
                                readOnly
                              />
                            </FormGroup>
                          </Col>
                          {/* <Col lg={6}>
                            <FormGroup>
                              <Label for="name">New Password (Optional)</Label>
                              <Input
                                type="password"
                                name="passowrd"
                                id="password"
                                value={userData.password}
                                className="form-control-alternative"
                                //required
                                onChange={(e) => {
                                  setUserData({
                                    ...userData,
                                    password: e.target.value,
                                    // name_insensitive: e.target.value.toLowerCase()
                                  });
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg={6}>
                            <FormGroup>
                              <Label for="name">Confirm Password</Label>
                              <Input
                                type="password"
                                name="passowrd"
                                id="password"
                                //value={userData.password}
                                className="form-control-alternative"
                                //required
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                }}
                                maxLength="25"
                                onInput={(object) => {
                                  if (
                                    object.target.value.length >
                                    object.target.maxLength
                                  )
                                    object.target.value =
                                      object.target.value.slice(
                                        0,
                                        object.target.maxLength
                                      );
                                }}
                              />
                            </FormGroup>
                          </Col> */}
                          {signedInUser.projectType === "progress" && (
                            <>
                              {registrationFeilds.includes("department") && (
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="type">Department</Label>
                                    <Input
                                      type="select"
                                      name="department"
                                      id="department"
                                      value={userData.department}
                                      className="form-control-alternative"
                                      required
                                      onChange={(e) => {
                                        setUserData({
                                          ...userData,
                                          department: e.target.value,
                                        });
                                      }}
                                    >
                                      {departments &&
                                        departments.map((_department) => (
                                          <option
                                            value={_department}
                                            key={_department}
                                          >
                                            {_.startCase(_department)}
                                          </option>
                                        ))}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              )}
                              {registrationFeilds.includes("region") && (
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="type">Region</Label>
                                    <Input
                                      type="select"
                                      name="region"
                                      id="region"
                                      value={userData.region}
                                      className="form-control-alternative"
                                      required
                                      onChange={(e) => {
                                        setUserData({
                                          ...userData,
                                          region: e.target.value,
                                        });
                                      }}
                                    >
                                      {regions &&
                                        regions.map((_region) => (
                                          <option value={_region} key={_region}>
                                            {_.startCase(_region)}
                                          </option>
                                        ))}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              )}
                            </>
                          )}
                          <Col lg={12}>
                            <div className="ml-4">
                              <Input
                                defaultChecked={
                                  userData.canExpire ? true : false
                                }
                                onChange={(e) => {
                                  setIsChecked(e.target.checked);
                                  if (!e.target.checked) {
                                    setUserData({
                                      ...userData,
                                      expiryDate: null,
                                    });
                                  }
                                }}
                                type="checkbox"
                              />
                              {/* <input type="checkbox" name="canexpire" value=""  ></input> */}
                              <Label check checked>
                                {" "}
                                Can expire?
                              </Label>
                            </div>

                            <FormGroup>
                              <DatePicker
                                disabled={!isChecked}
                                selected={userData.expiryDate}
                                onChange={(date) => {
                                  setStartDate(date);
                                  setUserData({
                                    ...userData,
                                    expiryDate: date,
                                  });
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="text-right">
                            <Button
                              color="danger"
                              onClick={() => history.goBack()}
                              disabled={loading === "saving"}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="primary"
                              type="submit"
                              disabled={loading === "saving"}
                            >
                              {loading === "saving" ? (
                                <Spinner color="light" size="sm" />
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                ) : (
                  <div className="text-center py-5 mt-5">
                    <Spinner color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
